<div class="loader-wrapper">
  <div class="bottom triangle"></div>
  <div class="top triangle"></div>
  <div class="left triangle"></div>
  <div class="right triangle"></div>
</div>
